import { registerChatwootEvents } from '../chatwoot'

const BASE_URL = 'https://app.chatwoot.com'

const WEBSITE_TOKEN_FRENCH = 'ryUb6J6AG465R1QDi5KjrXfT'
const WEBSITE_TOKEN_ENGLISH = 'V3jQSxoXtq6deWxKyecnE7q6'

/**
 * @param {`${import('acces-impot-utils/lib/translation').LANGUAGES}`} language
 *
 * @see https://www.chatwoot.com/hc/user-guide/articles/1677587234-how-to-send-additional-user-information-to-chatwoot-using-sdk
 */
export default function (language) {
  ;(function (d, t) {
    const g = d.createElement(t),
      s = d.getElementsByTagName(t)[0]
    g.src = BASE_URL + '/packs/js/sdk.js'
    g.defer = true
    g.async = true
    s.parentNode.insertBefore(g, s)
    g.onload = function () {
      // Has been reported as sometimes undefined (might be blocked)
      if (!window.chatwootSDK) return

      window.chatwootSDK.run({
        websiteToken: language === 'fr' ? WEBSITE_TOKEN_FRENCH : WEBSITE_TOKEN_ENGLISH,
        baseUrl: BASE_URL,
      })
      registerChatwootEvents()
    }
  })(document, 'script')
}
